import TenantInfo from '../../components/settings/tenant/TenantInfo'

const Tenant = () => {
  return (
    <div className="mb-2 flex w-full flex-col">
      <TenantInfo />
    </div>
  )
}

export default Tenant
